import { useState } from 'react'

import { AvailableModules } from 'generated/featureDefinitions'
import { ItemIntegrationFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { upsellableIntegrations } from 'modules/marketplace/components/Item/InstallWorkflow/UpsellModal/upsellableIntegrations'
import { UpsellModalButton } from 'modules/marketplace/components/Item/InstallWorkflow/UpsellModalButton'
import { useGetMarketplaceIntegrationUpsells } from 'modules/marketplace/hooks/integrations/useGetMarketplaceIntegrationUpsells'
import { PAYROLL_CATEGORY_ID } from 'modules/marketplace/hooks/usePaywall'
import { locale } from 'modules/marketplace_modules/components/utils/locales'
import RequestUpgradeModal from 'modules/upsell/components/RequestUpgradeModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

import { CompensationsUpsellModal } from './CompensationsUpsellModal'

interface UpsellModalInterface {
  integration: ItemIntegrationFragment
}

export const UpsellModal = ({ integration }: UpsellModalInterface) => {
  const [upsellModalVisible, setUpsellModalVisible] = useState(false)
  const { access } = useCurrentSession()
  const datoFormatLocale = locale[access.locale]
  const featureId = upsellableIntegrations[integration.datoId]?.id

  const upsellButtonClick = () => {
    setUpsellModalVisible(true)
    track(trackingEvents.marketplace.clickIntegrationShowUpsellModal)
  }

  const { data } = useGetMarketplaceIntegrationUpsells({
    integrationDatoId: integration.datoId,
    locale: datoFormatLocale,
  })
  const modalData = data?.[0]

  if (!upsellModalVisible) return <UpsellModalButton openUpsellModal={upsellButtonClick} />

  return (
    <>
      <UpsellModalButton openUpsellModal={upsellButtonClick} />
      {integration.category?.id === PAYROLL_CATEGORY_ID ? (
        <CompensationsUpsellModal
          integration={integration}
          onClose={() => setUpsellModalVisible(false)}
          featureId={featureId}
        />
      ) : (
        <RequestUpgradeModal
          title={modalData?.title || undefined}
          description={modalData?.description || undefined}
          customSuccessDescription={modalData?.successDescription || undefined}
          requestReason={ValidReasons.MissingAddon}
          requestSource={`integration-${integration.slug}`}
          moduleRequested={AvailableModules.marketplace}
          featureRequested={featureId}
          onClose={() => setUpsellModalVisible(false)}
        />
      )}
    </>
  )
}
